import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { SelectTemplate } from '../../pages/SelectTemplate';
import { Editor } from '../../pages/Editor';
import { Checkout } from '../../pages/Checkout';
import { NotFound } from '../../pages/404';
import { CheckoutFinished } from '../../pages/CheckoutFinished';

import styles from './styles.module.scss';

export const Router = () => {
    const { pathname } = useLocation();

    return (
        <div className={styles.outerWrapper}>
            <div className={styles.innerWrapper}>
                <Routes key={pathname}>
                    <Route path="/" element={<SelectTemplate />} />
                    <Route path="/editor" element={<Editor />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/finished" element={<CheckoutFinished />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </div>
    );
};
